<template>
	<div>
		<busquedaAlumno />
		<br />
		<infoEvaluacion />
	</div>
</template>
<script>
import busquedaAlumno from "@/components/evaluacion/busquedaEvaluacion";
import infoEvaluacion from "@/components/evaluacion/infoEvaluacionCurso";
import tablaAlumno from "@/components/evaluacion/tablaAlumno";
import { mapActions, mapState } from "vuex";
export default {
	components: {
		tablaAlumno,
		busquedaAlumno,
		infoEvaluacion
	},
	data() {
		return {};
	},
	computed: {
		...mapState("curso", ["jsonCurso"]),
		...mapState("curso",["campusSeleccionadoMulti"]),
	},
	methods: {
		...mapActions("menu", ["updateMenu"]),
		...mapActions("menu", ["updateTitulo"]),
		...mapActions('curso',['updateCursoSearch']),
		async getCurso() {
			let url = "api/getCursoCoordinadora";
			if(this.campusSeleccionadoMulti.idCampus != undefined){
				url = url + "/" + this.campusSeleccionadoMulti.idCampus;
			}
			const { data } = await this.axios.get(url);
			const { listadoCursos } = data;

			const cursos = listadoCursos.map((cursos) => ({
				...cursos,
				tituloCurso: `# ${cursos.idCurso} ${cursos.tituloCurso}`,
			}));
			this.updateCursoSearch(cursos);
		},
	},
	created() {
		let menu = [
			{
				urlTolbar: "index",
				nameToolbar: "Inicio"
			},
			{
				urlTolbar: "evaluacion-curso",
				nameToolbar: "evaluacion-curso"
			}
		];
		let titulo = "Panel evaluación curso";
		this.updateTitulo(titulo);
		this.updateMenu(menu);
		this.getCurso();
	}
};
</script>
